/**
 * Machine Constants
 * 
 * Centralized constants for machine-related calculations.
 * These match the backend constants for consistency.
 */

export const MACHINE_CONSTANTS = {
  // Shift timing constants
  SHIFT_START_HOUR: 8,              // Shift starts at 8 AM
  DAY_SHIFT_DURATION: 11,           // Day shift duration: 8 AM to 7 PM = 11 hours
  NIGHT_SHIFT_START_HOUR: 19,       // Night shift starts at 7 PM (19:00)
  
  // Timezone
  TIMEZONE: 'Asia/Kolkata',         // Default timezone for all calculations
} as const;

export const STOP_REASONS = [
  { value: 'maintenance', label: 'Maintenance' },
  { value: 'power_cut', label: 'Power Cut' },
  { value: 'beam_change', label: 'Beam Change' },
  { value: 'warp_break', label: 'Warp Break' },
  { value: 'weft_break', label: 'Weft Break' },
  { value: 'quality_issue', label: 'Quality Issue' },
  { value: 'operator_break', label: 'Operator Break' },
  { value: 'other', label: 'Other' },
] as const;

export type StopReason = typeof STOP_REASONS[number]['value'];
